/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { generateArrayOfNumbers } from '../utils/number';

export const SourceTypes = {
  COMPOSITE: 'composite',
  FRAGMENT: 'fragment',
  SUB_FRAGMENT: 'sub_fragment',
};

export const SDG_CODES = generateArrayOfNumbers(1, 17);

export const DEFAULT_METRIC_UNIT = '';

export const TOTAL_OPTION = { value: 'total', label: 'Total' };